import 'isomorphic-fetch';
import { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

export type productEditionType = {
  readonly cloudId: string | undefined;
  readonly productKey: string;
  readonly wacEnvUrl: string;
  readonly createAnalyticsEvent: CreateUIAnalyticsEvent;
};

export type EditionStatusType = {
  readonly edition?: string;
  readonly error?: string;
};

export async function checkProductEdition({
  cloudId,
  productKey,
  wacEnvUrl,
  createAnalyticsEvent
}: productEditionType) {
  const productEditionStatusResponse = await fetch(
    `${wacEnvUrl}/gateway/api/cloud/edition/${cloudId}/${productKey}`,
    {
      headers: {
        'content-type': 'application/json'
      },
      method: 'GET',
      credentials: 'include'
    }
  );

  const productEditionStatus =
    (await productEditionStatusResponse.json()) as EditionStatusType;

  if (productEditionStatus.error) {
    // If edition is free the response comes back as { "error": "Product Edition Not Found" }
    const isFreeEdition =
      productEditionStatus.error === 'Product Edition Not Found';
    if (isFreeEdition) {
      return 'free';
    }

    if (!isFreeEdition) {
      createAnalyticsEvent({
        eventName: 'bxp.cloud.edition.failed',
        errorMessage: productEditionStatus.error
      }).fire();
    }

    return null;
  }

  return productEditionStatus.edition;
}
